import React from "react";
import { Box } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { CPCustomFormReportDocumentDetail } from "../../../api/models/unified";

interface Props {
  documentDetail: CPCustomFormReportDocumentDetail;
}

const DocumentInfoBox: React.FC<Props> = (props): React.ReactElement => {
  const { documentDetail } = props;
  const { tReport } = useCustomTranslation();

  return (
    <Box
      className="mb-4"
      title={tReport("basic_info")}
      cols={2}
      items={[
        { label: tReport("order_code"), value: documentDetail.orderCode },
        { label: tReport("name"), value: documentDetail.name },
      ]}
    />
  );
};

export default DocumentInfoBox;
